(function () {
    'use strict';

    angular.module('ecap', [
        //External modules (must be defined first followed by our own modules):
        'ngAnimate',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngCookies',
        'ngMaterial',
        'ui.router',
        'ngSanitize',
        'ngRoute',
        'duScroll',
        'ui.bootstrap',
        'ui.slider',
        'ui.tinymce',
        'checklist-model',
        'angularProgressbar',
        //'sticky',
        'hl.sticky',
        'dndLists',
        'toastr',
        'slick',
        'angularTrix',
        'infinite-scroll',
        //Our modules:
        'ecap.common',
        'ecap.registration',
        'ecap.crm',
        'ecap.dashboards',
        'ecap.siteConfiguration',
        'ecap.workflow',
        'ecap.requestForProposal',
        'ecap.subscriptions'
    ]);

    var EcapRun = function ($rootScope, $state, $log, chatlioService) {
        //chatlioService.initialize();

        $rootScope.$state = $state;

        $rootScope.$on('$stateChangeStart', function (evt, to, params) {
            if (to.redirectTo) {
                evt.preventDefault();
                $state.go(to.redirectTo, params, { location: 'replace' });
            }
        });

        $rootScope.$on('$stateNotFound',
            function (event, unfoundState, fromState, fromParams) {
                $log.debug(unfoundState.to); // "lazy.state"
                $log.debug(unfoundState.toParams); // {a:1, b:2}
                $log.debug(unfoundState.options); // {inherit:false} + default options
            });

        $rootScope.$on('$stateChangeError',
            function (event, toState, toParams, fromState, fromParams, error) {
                $log.debug(toState);
                $log.debug(toParams);
                $log.debug(fromState);
                $log.debug(fromParams);
                $log.debug(error);
            });

        $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
            $log.debug('$stateChangeSuccess to '+
                toState.name +
                '- fired once the state transition is complete.');
            });

        $rootScope.$on('$viewContentLoading',function(event, viewConfig){
            $log.debug('$viewContentLoading - view begins loading - dom not rendered',
                viewConfig);
        });
    };

    EcapRun.$inject = ['$rootScope', '$state', '$log', 'chatlioService'];
    angular.module('ecap').run(EcapRun);

    var EcapConfig = function ($httpProvider, $routeProvider, $locationProvider,
        $urlRouterProvider, toastrConfig, $mdIconProvider) {

        $mdIconProvider
            .defaultFontSet('FontAwesome')
            .fontSet('fa', 'FontAwesome');

        $httpProvider.interceptors.push('httpInterceptor');

        //use html5 mode to enable the use of regular urls without the use of hasbangs.
        var ishtml5Mode = ($('html').hasClass('history'));
        if (ishtml5Mode) {
            $locationProvider.html5Mode({
                enabled: true,
                rewriteLinks: false
            });
        }
        $locationProvider.hashPrefix('!');

        function replaceDynamicList(obj) {
            var k;
            var has = Object.prototype.hasOwnProperty.bind(obj);
            for (k in obj) if (has(k)) {
                switch (typeof obj[k]) {
                    case "object":
                        if (obj[k] != null && obj[k]["$values"]) {
                            obj[k] = obj[k]["$values"];
                        }
                        else {
                            replaceDynamicList(obj[k]);
                        }
                        break;
                }
            }

            return obj;
        };

        $httpProvider.defaults.transformResponse.push(function (response) {
            return replaceDynamicList(response);
        });

        // Example of using function rule as param
        $urlRouterProvider.otherwise(function ($injector, $location) {
            // do nothing
        });

        tinyMCE.baseURL = '/bundles/js/tinymce';

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            newestOnTop: true,
            positionClass: 'toast-top-full-width',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    };

    EcapConfig.$inject =['$httpProvider', '$routeProvider', '$locationProvider', '$urlRouterProvider', 'toastrConfig','$mdIconProvider'];
    angular.module('ecap').config(EcapConfig);

    var httpInterceptor = function ($q, $rootScope, $injector) {
        function modifyRequest(requestOptions, req) {
            if (requestOptions.AuthorizationHeader) {
                req.headers['Authorization'] = requestOptions.AuthorizationHeader;
            }

            var baseUrlSegment = req.url.split('/')[0].replace('[', '').replace('Host]', '');
            if (requestOptions.ApiBaseUrls[baseUrlSegment]) {
                req.url = req.url.replace('[' + baseUrlSegment + 'Host]/', requestOptions.ApiBaseUrls[baseUrlSegment]);
            }
        }

        var requestOptions;
        var interceptor = {
            responseError: function (response) {
                $rootScope.$broadcast("response_error", response.status);
                return $q.reject(response);
            },
            request: function (req) {
                if (req.url === '/requestoptions') {
                    if (!requestOptions || !requestOptions.TokenExpirationDate ||
                        moment.utc().isAfter(moment(requestOptions.TokenExpirationDate))) {
                        req.cache = true;
                    }

                    return req;
                }

                if (!requestOptions || moment.utc().isAfter(moment(requestOptions.TokenExpirationDate))) {
                    return $injector.get('requestOptionsDataService').getRequestOptions()
                        .then(function (res) {
                            requestOptions = res;
                            modifyRequest(requestOptions, req);
                            return req;
                        });
                }
                else {
                    modifyRequest(requestOptions, req);
                    return req;
                }
            }
        }
        return interceptor;
    };

    httpInterceptor.$inject = ['$q', '$rootScope', '$injector'];
    angular.module('ecap').factory('httpInterceptor', httpInterceptor);

    angular.module('ecap').constant("STATES_LIST", [
        { abbrev: "", name: "" },
        { abbrev: "AL", name: "Alabama" },
        { abbrev: "AK", name: "Alaska" },
        { abbrev: "AZ", name: "Arizona" },
        { abbrev: "AR", name: "Arkansas" },
        { abbrev: "CA", name: "California" },
        { abbrev: "CO", name: "Colorado" },
        { abbrev: "CT", name: "Connecticut" },
        { abbrev: "DE", name: "Delaware" },
        { abbrev: "FL", name: "Florida" },
        { abbrev: "GA", name: "Georgia" },
        { abbrev: "HI", name: "Hawaii" },
        { abbrev: "ID", name: "Idaho" },
        { abbrev: "IL", name: "Illinois" },
        { abbrev: "IN", name: "Indiana" },
        { abbrev: "IA", name: "Iowa" },
        { abbrev: "KS", name: "Kansas" },
        { abbrev: "KY", name: "Kentucky" },
        { abbrev: "LA", name: "Louisiana" },
        { abbrev: "ME", name: "Maine" },
        { abbrev: "MD", name: "Maryland" },
        { abbrev: "MA", name: "Massachusetts" },
        { abbrev: "MI", name: "Michigan" },
        { abbrev: "MN", name: "Minnesota" },
        { abbrev: "MS", name: "Mississippi" },
        { abbrev: "MO", name: "Missouri" },
        { abbrev: "MT", name: "Montana" },
        { abbrev: "NE", name: "Nebraska" },
        { abbrev: "NV", name: "Nevada" },
        { abbrev: "NH", name: "New Hampshire" },
        { abbrev: "NJ", name: "New Jersey" },
        { abbrev: "NM", name: "New Mexico" },
        { abbrev: "NY", name: "New York" },
        { abbrev: "NC", name: "North Carolina" },
        { abbrev: "ND", name: "North Dakota" },
        { abbrev: "OH", name: "Ohio" },
        { abbrev: "OK", name: "Oklahoma" },
        { abbrev: "OR", name: "Oregon" },
        { abbrev: "PA", name: "Pennsylvania" },
        { abbrev: "RI", name: "Rhode Island" },
        { abbrev: "SC", name: "South Carolina" },
        { abbrev: "SD", name: "South Dakota" },
        { abbrev: "TN", name: "Tennessee" },
        { abbrev: "TX", name: "Texas" },
        { abbrev: "UT", name: "Utah" },
        { abbrev: "VT", name: "Vermont" },
        { abbrev: "VA", name: "Virginia" },
        { abbrev: "WA", name: "Washington" },
        { abbrev: "WV", name: "West Virginia" },
        { abbrev: "WI", name: "Wisconsin" },
        { abbrev: "WY", name: "Wyoming" },
        { abbrev: "DC", name: "Washington DC" }
    ]);
})();